import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=5115e4f0&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5115e4f0', component.options)
    } else {
      api.reload('5115e4f0', component.options)
    }
    module.hot.accept("./VerDetalleModal.vue?vue&type=template&id=5115e4f0&", function () {
      api.rerender('5115e4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerie/VerDetalleModal.vue"
export default component.exports